import { defineFcm } from '../shared/factory';

export const FCM_PRIVACY_HIDE_RECRUITER = defineFcm('privacy_hide_recruiter')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Petition page',
		description: `Indicates whether to hide the recruiter name on the petition page, based on the recruiter's country. Personalized links for facebook will not be created.
			Bandatized links will not be created.

			Locale configs will be ignored.

			Related to petition_display_recruiter_name (which conditions the feature itself).`,
	});
